<template>
    <div class="mainContainer">
          <div class="tabs">
                    <DemandList />
           </div>
        </div>
</template>

<script>
import DemandList from '../../components/Demand/DemandListCom';
export default {
  data(){
    return{
    }
  },
  created(){
  },
  components:{
    DemandList
  },
  methods:{
  }
}
</script>
